module.exports = __webpack_public_path__ + "static/media/goggle-map.6cf9dfda.svg";